import { render } from "./PagesTable.vue?vue&type=template&id=43feead8"
import script from "./PagesTable.vue?vue&type=script&lang=js"
export * from "./PagesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__